<template>
  <div>
    <h5>Nächste Termine:</h5>
    <b-list-group to="/Kalender">
      <CalendarShortListEntry
        v-for="event in events"
        :key="event.id"
      />
    </b-list-group>
  </div>
</template>

<script>
import CalendarShortListEntry from '@/components/Calendar/CalendarShortListEntry'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CalendarShortList',
  components: { CalendarShortListEntry },
  computed: {
    ...mapGetters([
      'getStoredLatestEvents'
    ]),
    events () {
      return this.getStoredLatestEvents
    }
  },
  mounted () {
    this.getLatestEvents()
  },
  methods: {
    ...mapActions([
      'getLatestEvents'
    ])
  }
}
</script>

<style scoped>
.list-group-item:first-child {
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
}

.list-group-item:last-child {
  border-bottom-right-radius: .25rem;
  border-bottom-left-radius: .25rem;
}
</style>
